import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #4CAF50;
    --secondary-color: #FFC107;
    --accent-color: #FF5722;
    --background-color: #F5F5F5;
    --text-color: #333333;

    --game-color-math: #2196F3;
    --game-color-english: #9C27B0;

    --success-color: #4CAF50;
    --error-color: #F44336;

    /* Define font family consistently for all devices */
    --font-family: 'Comic Neue', 'Comic Sans MS', 'Comic Sans', cursive, sans-serif;
    --border-radius: 12px;
    --box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    /* Apply font smoothing consistently */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: var(--font-family);
    background-color: var(--background-color);
    color: var(--text-color);
    line-height: 1.6;
    overflow-x: hidden;
    /* Force font application */
    -webkit-text-size-adjust: 100%;
  }

  /* Ensure all text elements use the defined font family */
  h1, h2, h3, h4, h5, h6, p, span, a, button, input, textarea, div {
    font-family: var(--font-family);
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700; /* Match Comic Neue bold weight */
    margin-bottom: 1rem;
  }

  button {
    cursor: pointer;
    border: none;
    font-family: var(--font-family);
    font-size: 1.2rem;
    padding: 0.75rem 1.5rem;
    border-radius: var(--border-radius);
    background-color: var(--primary-color);
    color: white;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: var(--box-shadow);
    }

    &:active {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  a {
    text-decoration: none;
    color: inherit;
    font-family: var(--font-family);
  }

  img {
    max-width: 100%;
  }

  /* iOS specific font fixes */
  @supports (-webkit-touch-callout: none) {
    body, button, a, div, p, span, h1, h2, h3, h4, h5, h6 {
      font-family: 'Comic Neue', 'Comic Sans MS', cursive, sans-serif !important;
    }
  }

  /* Media query for mobile devices */
  @media (max-width: 768px) {
    body {
      font-size: 16px;
    }

    /* Adjust heading sizes on mobile */
    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.75rem;
    }

    h3 {
      font-size: 1.5rem;
    }
  }
`;

export default GlobalStyles;
